<template>
  <div class="tiptap-editor">
    <!-- 🔧 Toolbar -->
    <div class="toolbar">
      <!-- Stil grubu -->
      <div class="toolbar-group">
        <button @click="toggle('bold')" :class="{ active: isActive('bold') }" title="Kalın">
          <b>B</b>
        </button>
        <button @click="toggle('italic')" :class="{ active: isActive('italic') }" title="İtalik">
          <i>I</i>
        </button>
        <button @click="toggle('underline')" :class="{ active: isActive('underline') }" title="Altı Çizili">
          <u>U</u>
        </button>
        <button @click="toggle('strike')" :class="{ active: isActive('strike') }" title="Üstü Çizili">
          <s>S</s>
        </button>
        <button @click="toggle('code')" :class="{ active: isActive('code') }" title="Kod">
          <code>&lt;/&gt;</code>
        </button>
      </div>

      <!-- Başlık grubu -->
      <div class="toolbar-group">
        <button @click="toggleHeading(1)" :class="{ active: isActive('heading', { level: 1 }) }">H1</button>
        <button @click="toggleHeading(2)" :class="{ active: isActive('heading', { level: 2 }) }">H2</button>
        <button @click="toggleHeading(3)" :class="{ active: isActive('heading', { level: 3 }) }">H3</button>
        <button @click="toggle('paragraph')" :class="{ active: isActive('paragraph') }">P</button>
        <button @click="toggle('blockquote')" :class="{ active: isActive('blockquote') }" title="Alıntı">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
          </svg>
        </button>
        <button @click="toggle('codeBlock')" :class="{ active: isActive('codeBlock') }" title="Kod Bloğu">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 3h18v18h-18v-18zm4 12.5v-1.5l-3 3 3 3v-1.5h7v-1.5h-7zm5-6.5h7v1.5h-7v1.5l3-3-3-3v1.5z"/>
          </svg>
        </button>
      </div>

      <!-- Liste -->
      <div class="toolbar-group">
        <button @click="toggle('bulletList')" :class="{ active: isActive('bulletList') }" title="Madde Listesi">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"/>
          </svg>
        </button>
        <button @click="toggle('orderedList')" :class="{ active: isActive('orderedList') }" title="Numaralı Liste">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 4h2v2H3V4zm4 0h14v2H7V4zM3 11h2v2H3v-2zm4 0h14v2H7v-2zM3 18h2v2H3v-2zm4 0h14v2H7v-2z"/>
          </svg>
        </button>
        <button @click="toggle('taskList')" :class="{ active: isActive('taskList') }" title="Görev Listesi">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 3h18v18H3V3zm4 4v2h10V7H7zm0 6v2h10v-2H7zm0 6v2h10v-2H7z"/>
          </svg>
        </button>
      </div>

      <!-- Hizalama -->
      <div class="toolbar-group">
        <button @click="align('left')" :class="{ active: isActive({ textAlign: 'left' }) }" title="Sola Hizala">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 5h18v2H3V5zm0 6h12v2H3v-2zm0 6h18v2H3v-2z"/>
          </svg>
        </button>
        <button @click="align('center')" :class="{ active: isActive({ textAlign: 'center' }) }" title="Ortala">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 5h18v2H3V5zm4 6h10v2H7v-2zm-4 6h18v2H3v-2z"/>
          </svg>
        </button>
        <button @click="align('right')" :class="{ active: isActive({ textAlign: 'right' }) }" title="Sağa Hizala">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 5h18v2H3V5zm6 6h12v2H9v-2zm-6 6h18v2H3v-2z"/>
          </svg>
        </button>
        <button @click="align('justify')" :class="{ active: isActive({ textAlign: 'justify'}) }" title="İki Yana Yasla">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M3 5h18v2H3V5zm0 6h18v2H3v-2zm0 6h18v2H3v-2z"/>
          </svg>
        </button>
      </div>

      <!-- Link, resim, yatay çizgi -->
      <div class="toolbar-group">
        <button @click="setLink" :class="{ active: isActive('link') }" title="Bağlantı">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M10.59 13.41c.41.39.41 1.03 0 1.42-.39.39-1.03.39-1.42 0a5.003 5.003 0 0 1 0-7.07l3.54-3.54a5.003 5.003 0 0 1 7.07 0 5.003 5.003 0 0 1 0 7.07l-1.49 1.49c.01-.82-.12-1.64-.4-2.42l.47-.48a2.982 2.982 0 0 0 0-4.24 2.982 2.982 0 0 0-4.24 0l-3.53 3.53a2.982 2.982 0 0 0 0 4.24zm2.82-4.24c.39-.39 1.03-.39 1.42 0a5.003 5.003 0 0 1 0 7.07l-3.54 3.54a5.003 5.003 0 0 1-7.07 0 5.003 5.003 0 0 1 0-7.07l1.49-1.49c-.01.82.12 1.64.4 2.43l-.47.47a2.982 2.982 0 0 0 0 4.24 2.982 2.982 0 0 0 4.24 0l3.53-3.53a2.982 2.982 0 0 0 0-4.24.973.973 0 0 1 0-1.42z"/>
          </svg>
        </button>
        <button @click="addImage" title="Resim Ekle">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14L6 17h12l-3.86-5.14z"/>
          </svg>
        </button>
        <button @click="editor.chain().focus().setHorizontalRule().run()" title="Yatay Çizgi Ekle">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M2 11h2v2H2v-2zm4 0h12v2H6v-2zm14 0h2v2h-2v-2z"/>
          </svg>
        </button>
      </div>

      <!-- Yazı rengi ve arka plan -->
      <div class="toolbar-group color-group">
        <label class="color-picker">
          <span class="color-icon" :style="{ color: textColor }">A</span>
          <input 
            type="color" 
            @input="setColor($event.target.value)" 
            :value="textColor"
            @click.stop
          />
        </label>
        <label class="color-picker">
          <span class="color-icon" :style="{ backgroundColor: highlightColor }">A</span>
          <input 
            type="color" 
            @input="setHighlight($event.target.value)" 
            :value="highlightColor"
            @click.stop
          />
        </label>
        <button @click="clearColor" title="Renkleri Sıfırla">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/>
          </svg>
        </button>
      </div>

      <!-- Font family ve boyutu -->
      <div class="toolbar-group">
        <select @change="setFontFamily($event.target.value)" v-model="selectedFont">
          <option value="">Font Seç</option>
          <option value="Arial">Arial</option>
          <option value="Georgia">Georgia</option>
          <option value="Courier New">Courier</option>
          <option value="Tahoma">Tahoma</option>
          <option value="Times New Roman">Times New Roman</option>
          <option value="Verdana">Verdana</option>
        </select>
        <select @change="setFontSize($event.target.value)" v-model="selectedFontSize">
          <option value="">Boyut</option>
          <option value="8px">8px</option>
          <option value="10px">10px</option>
          <option value="12px">12px</option>
          <option value="14px">14px</option>
          <option value="16px">16px</option>
          <option value="18px">18px</option>
          <option value="20px">20px</option>
          <option value="24px">24px</option>
          <option value="32px">32px</option>
        </select>
      </div>

      <!-- Geri al/Yinele -->
      <div class="toolbar-group">
        <button @click="editor.chain().focus().undo().run()" :disabled="!editor.can().undo()" title="Geri Al">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M5.828 7l2.536 2.536L6.95 10.95 2 6l4.95-4.95 1.414 1.414L5.828 5H13a8 8 0 1 1 0 16H4v-2h9a6 6 0 1 0 0-12H5.828z"/>
          </svg>
        </button>
        <button @click="editor.chain().focus().redo().run()" :disabled="!editor.can().redo()" title="Yinele">
          <svg width="16" height="16" viewBox="0 0 24 24">
            <path fill="currentColor" d="M18.172 7l-2.536 2.536L17.05 10.95 22 6l-4.95-4.95-1.414 1.414L18.172 5H11a8 8 0 1 0 0 16h9v-2h-9a6 6 0 1 1 0-12h7.172z"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- ✍️ Editor Alanı -->
    <editor-content :editor="editor" class="editor-content" />
  </div>
</template>

<script setup>
import { ref, watch, onBeforeUnmount } from 'vue'
import { Editor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import { FontFamily } from '@tiptap/extension-font-family'
import TaskList from '@tiptap/extension-task-list'
import TaskItem from '@tiptap/extension-task-item'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['update:modelValue'])

const textColor = ref('#000000')
const highlightColor = ref('#FFFF00')
const selectedFont = ref('')
const selectedFontSize = ref('')

const editor = new Editor({
  content: props.modelValue,
  extensions: [
    StarterKit, // Artık codeBlock burada aktif
    Underline,
    TextStyle,
    FontFamily,
    TextAlign.configure({
      types: ['heading', 'paragraph'],
      alignments: ['left', 'center', 'right', 'justify'],
      defaultAlignment: 'left'
    }),
    Color,
    Highlight.configure({ multicolor: true }),
    Link.configure({
      openOnClick: false,
      HTMLAttributes: {
        rel: 'noopener noreferrer',
        target: '_blank',
      },
    }),
    Image.configure({
      inline: true,
      allowBase64: true,
      HTMLAttributes: {
        class: 'editor-image',
      },
    }),
    TaskList,
    TaskItem.configure({ nested: true }),
  ],
  onUpdate: ({ editor }) => {
    const html = editor.getHTML()
    emit('update:modelValue', html)
    textColor.value = editor.getAttributes('textStyle').color || '#000000'
    highlightColor.value = editor.getAttributes('highlight').color || '#FFFF00'
    selectedFont.value = editor.getAttributes('textStyle').fontFamily || ''
    selectedFontSize.value = editor.getAttributes('textStyle').fontSize || ''
  },
})

watch(() => props.modelValue, (newValue) => {
  const isSame = editor.getHTML() === newValue
  if (!isSame) {
    editor.commands.setContent(newValue, false)
    textColor.value = editor.getAttributes('textStyle').color || '#000000'
    highlightColor.value = editor.getAttributes('highlight').color || '#FFFF00'
  }
})

const toggle = (command) => {
  editor.chain().focus()[`toggle${capitalize(command)}`]().run()
}
const toggleHeading = (level) => {
  editor.chain().focus().toggleHeading({ level }).run()
}
const align = (dir) => {
  editor.chain().focus().setTextAlign(dir).run()
}
const setLink = () => {
  const previousUrl = editor.getAttributes('link').href
  const url = prompt('Bağlantı URL:', previousUrl || 'https://')
  if (url === null) return
  if (url === '') {
    editor.chain().focus().extendMarkRange('link').unsetLink().run()
    return
  }
  editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
}
const addImage = () => {
  const url = prompt('Resim URL:')
  if (url) {
    editor.chain().focus().setImage({ src: url }).run()
  }
}
const setColor = (color) => {
  if (!color) return
  editor.chain().focus().setColor(color).run()
  textColor.value = color
}
const setHighlight = (color) => {
  if (!color) return
  editor.chain().focus().setHighlight({ color }).run()
  highlightColor.value = color
}
const clearColor = () => {
  editor.chain().focus().unsetColor().unsetHighlight().run()
  textColor.value = '#000000'
  highlightColor.value = '#FFFF00'
}
const setFontFamily = (font) => {
  if (!font) {
    editor.chain().focus().unsetFontFamily().run()
  } else {
    editor.chain().focus().setFontFamily(font).run()
  }
}
const setFontSize = (size) => {
  if (!size) {
    editor.chain().focus().unsetFontSize().run()
  } else {
    editor.chain().focus().setFontSize(size).run()
  }
}
const isActive = (command, attributes = {}) => {
  return editor.isActive(command, attributes)
}
const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1)

onBeforeUnmount(() => {
  editor.destroy()
})
</script>

<style scoped>
.tiptap-editor {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  color: #1a202c;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  align-items: center;
}

.toolbar-group {
  display: flex;
  gap: 6px;
  background: #fff;
  padding: 6px 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  align-items: center;
}

.toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 8px;
  font-size: 14px;
  border-radius: 4px;
  color: #4a5568;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.toolbar button:hover {
  background-color: #edf2f7;
  color: #2d3748;
}

.toolbar button.active {
  background-color: #4299e1;
  color: white;
}

.toolbar button.active:hover {
  background-color: #3182ce;
}

.toolbar button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.toolbar select {
  padding: 6px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 14px;
  color: #4a5568;
  background-color: #fff;
  cursor: pointer;
  max-width: 120px;
}

.toolbar select:focus {
  outline: none;
  border-color: #4299e1;
}

.color-group {
  gap: 4px;
}

.color-picker {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.color-icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-weight: bold;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.color-picker input[type="color"] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.editor-content {
  padding: 16px;
  min-height: 300px;
  font-size: 16px;
  line-height: 1.6;
  color: #1a202c;
  outline: none;
}

.editor-content:focus {
  outline: none;
}

/* TipTap özel stilleri */
.editor-content p {
  margin: 0 0 1em 0;
}

.editor-content h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

.editor-content h2 {
  font-size: 1.5em;
  margin: 0.75em 0;
}

.editor-content h3 {
  font-size: 1.17em;
  margin: 0.83em 0;
}

.editor-content ul,
.editor-content ol {
  padding-left: 2em;
  margin: 1em 0;
}

.editor-content a {
  color: #3182ce;
  text-decoration: underline;
}

.editor-content img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.editor-content blockquote {
  border-left: 3px solid #e2e8f0;
  padding-left: 1em;
  margin: 1em 0;
  color: #4a5568;
}

.editor-content pre {
  background: #f8fafc;
  padding: 1em;
  border-radius: 4px;
  overflow-x: auto;
}

.editor-content code {
  background: #f8fafc;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-family: monospace;
}

.editor-content .editor-image {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1em 0;
}

.editor-content .task-list-item {
  display: flex;
  align-items: center;
}

.editor-content .task-list-item-checkbox {
  margin-right: 0.5em;
}
</style>